import {useMemo} from 'preact/hooks';

import {isMobileDevice} from 'utilities/dom';
import {getConfiguration} from 'utilities/configuration';
import {useI18n} from 'utilities/i18n';

import {useLazyImage} from '../../hooks';

import styles from './BrandDetails.css';

export function BrandDetails() {
  const {shopPromiseWebsiteUrl} = getConfiguration();
  const {translate} = useI18n();
  const logoImg = useLazyImage('shop-promise-logo');
  const isMobile = isMobileDevice();
  const title = useMemo(() => translate('brandDetails.alt'), [translate]);

  return (
    <div className={styles.brandDetails}>
      {isMobile && (
        <a
          href={shopPromiseWebsiteUrl}
          tabIndex={0}
          target="_blank"
          rel="nofollow noreferrer"
          aria-label={title}
        >
          {logoImg && <img src={logoImg} alt={title} />}
        </a>
      )}
      {!isMobile && <h3>{translate('brandDetails.title')}</h3>}
      <p>{translate('brandDetails.textContent')}</p>
      <a
        href={shopPromiseWebsiteUrl}
        tabIndex={0}
        target="_blank"
        rel="nofollow noreferrer"
        aria-label={title}
      >
        {translate('brandDetails.learnMore')}
      </a>
    </div>
  );
}
